import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { DeleteConfirmCSSStyleImpl } from './deleteconfirmationcss';
import { DeleteConfirmViewImpl } from './deleteconfirmationview';

export interface DeleteConfirmComponentProps extends UIComponentProps
{
    headerTitle: string;
    id:string;
    msg:string;
    // showPopup(msg:string, type:AlertType,title:string):void;
    closePopup(): void;
    onConfirmClick(): void;
    onCancelClick():void;
}

export interface DeleteConfirmComponentHandler extends UIComponentHandler
{
    closePopup(): void;
    onConfirmClick(): void;
    onCancelClick():void;
}

export class DeleteConfirmComponent extends UIComponentImpl<DeleteConfirmComponentProps, UIComponentState, UIDataModel> 
implements DeleteConfirmComponentHandler
{
    constructor(props: DeleteConfirmComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DeleteConfirmViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DeleteConfirmCSSStyleImpl(applicationContext);
    }

  
    onConfirmClick(): void 
    {
       this.props.onConfirmClick();
    }

    onCancelClick():void
    {
        this.props.onCancelClick();
    }


    closePopup():void
    {
        this.props.onCancelClick();
    }
   
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/deleteconfirmation/deleteconfirmationcomponent.tsx